export default __webpack_public_path__ + "static/media/filter-cancel.10607c9b.svg";